export default __webpack_public_path__ + "static/media/4a.ee20f0a9.png";